import { Theme } from '@material-ui/core/styles';

export const getMuiDialogContent = (theme: Theme): Record<string, unknown> => ({
  MuiDialogContent: {
    root: {
      display: 'flex',
      flexFlow: 'column nowrap',
      padding: theme.spacing(0, 2, 2),

      '& .MuiFormControl-root': {
        marginBottom: theme.spacing(1),
      },

      '& .fd-text__h1': {
        fontSize: theme.typography.pxToRem(28),
      },

      '& .fd-text__body1': {
        marginBottom: theme.spacing(2),
      },

      '& label': {
        paddingBottom: theme.spacing(2),
      },

      '& .fd-list .fd-text__body1': {
        marginBottom: 0,
      },

      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(0, 2.5, 2.5),

        '& .fd-text__h2': {
          marginBottom: theme.spacing(2.5),
        },

        '& .fd-text__body1': {
          marginBottom: theme.spacing(2.5),
        },

        '& .fd-list .fd-text__body1': {
          marginBottom: 0,
        },

        '& [class*=snackbar]': {
          '& .fd-text__body1': {
            marginBottom: 0,
          },
        },
      },
    },
  },
});
